export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-six-cf19f93c9cb076512a2ea61cc9ac3247.svg";